module.exports = __webpack_public_path__ + "static/media/piletite_valimine.4a1d889d.png";